<template>
  <b-tr>
    <!-- primary_forage -->
    <b-td
      class="cell-table large-column"
      :class="getClassForCell(forage.primary_forage,isFieldInCache(field,year,rowIndex,'primary_forage'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="primaryForageChoices"
        item-text="display_name"
        item-value="value"
        v-model="primaryForage"
        choiceName="pasture_forage_primary_forage"
        :append-icon="
          forage.primary_forage !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('primaryForage', primaryForage)"
      />
    </b-td>
    <b-td
      :class="getClassForCell(forage.paddock,isFieldInCache(field,year,rowIndex,'paddock'))"
      class="cell-table large-column"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="pasturePaddocks"
        item-text="name"
        item-value="id"
        v-model="selectedPaddock"
        choiceName="pasture_paddock"
        :append-icon="
          forage.paddock !== null
          ? 'mdi-check-circle-outline'
          : ''
        "

        @click:append="handleClickSubmit('paddock', selectedPaddock)"
      />
    </b-td>
    <b-td class="cell-table white">
      <v-btn icon x-small color="black" @click="handleAdd">
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-small color="black" @click="handleDelete" v-if="dataLength > 1">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>.
    </b-td>
  </b-tr>
</template>
<script>
import { mapMutations, mapGetters,mapActions } from "vuex"
import { Defaults } from "@/store/modules"
import { getClassForCell } from "../utils"
import PracticeChoiceDropdown from "@/components/dropdowns/PracticeChoiceDropdown"

export default {
  name: "RanchForageRow",
  props: {
    additionView: { type: Boolean, default: false },
    cropId: { type: Number },
    field: { type: String },
    forage: { type: Object },
    rowIndex: { type: Number },
    dataLength: { type: Number },
    year: { type: String },
  },
  components: {
    PracticeChoiceDropdown,
  },
  data() {
    return {
      showDate: false,
      getClassForCell,
    }
  },
  computed: {
    ...mapGetters({
      practiceChoices: Defaults.Getters.getPracticeChoices,
      isFieldInCache: Defaults.Getters.isFieldInCache,
      pasturePaddocks: Defaults.Getters.getPasturePaddocks
    }),
    primaryForageChoices() {
      return this.practiceChoices["pasture_forage_primary_forage"]
    },
    primaryForage: {
      get() {
        return this.forage.primary_forage
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "forage",
          dataSetting: "primary_forage",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    selectedPaddock: {
      get() {
        return this.forage.paddock
      },
      set(val) {
        const updatePayload = {
        fieldId: this.field,
        year: this.year,
        crop: this.cropId,
        dataCategory: "forage",
        dataSetting: "paddock",
        value: val,
        rowIndex: this.rowIndex,
      }
      this.spreadsheetUpdate(updatePayload)
      }
    },
  },
  methods: {
    ...mapMutations({
      addFieldSettingRow: Defaults.Mutations.addFieldSettingRow,
      deleteNewFieldSetting: Defaults.Mutations.deleteNewFieldSetting,
      updateNewFieldSetting: Defaults.Mutations.updateNewFieldSetting,
      spreadsheetMutate: Defaults.Mutations.spreadsheetMutate,
    }),
    ...mapActions({
      spreadsheetUpdate: Defaults.Actions.spreadsheetUpdate,
    }),
    handleClickSubmit(setting, val) {
      this[setting] = val
    },
    handleCopy() {
      this.$emit("handle-copy", this.forage)
    },
    handleAdd() {
      const payloadObj = {
        crop_id: this.cropId,
        primary_forage: null,
        year:this.year,
        defaults_template:this.forage.defaults_template,
      }
      this.addFieldSettingRow({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "forage",
        dataObj: payloadObj,
        year: this.year,
      })
    },
    handleDelete() {
      this.deleteNewFieldSetting({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "forage",
        recordId: this.forage.id,
        rowIndex: this.rowIndex,
        year: this.year,
      })
    },
    handleValidateValue(val, type, length = 24) {
      function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
      }

      if (val === null) {
        return true
      }

      if (val.length > length) {
        this.$emit(
          "bad-input",
          "Inputted value length was too long (24 characters allowed)."
        )
        return false
      }

      if (type == "number") {
        if (isNumeric(val)) {
          return true
        } else {
          this.$emit(
            "bad-input",
            "Look out! A numerical value is expected here."
          )
          return false
        }
      } else if (type == "string") {
        return true
      }
    },
    filter(event) {
      event = event ? event : window.event
      let expect = event.target.value.toString() + event.key.toString()

      let validVal = this.handleValidateValue(expect, "number", 24)
      if (!validVal) event.preventDefault()
    },
  },
}
</script>
<style scoped>
.arva-alert {
  background-color: #f7c0be;
}

.cell-table {
  padding: 2px 6px;
}

.pre-gen {
  background-color: #fedb80;
}

.bg-white {
  color: white;
}

.cell-text {
  font-weight: 600;
  color: white;
}

.machine {
  background-color: #c0dce2;
}

.complete {
  background-color: #c7e3c1;
}

.copy-icon {
  cursor: pointer;
  color: #0f9aee;
}

.delete {
  color: #cc0101;
  cursor: pointer;
}

.input-check {
  cursor: pointer;
}

.select-check {
  margin-top: 14px;
  cursor: pointer;
}

.submit-icon {
  color: #c7e3c1;
}

.medium-column {
  width: 140px;
}

.large-column {
  width: 240px;
}

.marge-column {
  width: 180px;
}

.v-input {
  font-size: 18px;
}
</style>
